/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_No_AdsInputs */

const en_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy a smoother, ad-free experience`)
};

const ar_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بتجربة أكثر سلاسة وخالية من الإعلانات`)
};

const de_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie ein flüssigeres, werbefreies Erlebnis`)
};

const es_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de una experiencia más fluida y sin anuncios`)
};

const fr_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez d'une expérience plus fluide et sans publicité`)
};

const it_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi un'esperienza più fluida e senza pubblicità`)
};

const ja_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告なしの、より快適な体験を実現`)
};

const ko_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 없이 쾌적한 사용 환경을 제공해요`)
};

const pt_br_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenha uma experiência mais tranquila, livre de anúncios`)
};

const ru_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Простое использование без рекламы`)
};

const th_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับประสบการณ์ที่ลื่นไหล ปราศจากโฆษณา`)
};

const tr_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha akıcı, reklamsız bir deneyimin keyfini çıkar`)
};

const zh_cn_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无广告，体验更顺畅`)
};

const zh_tw_onboarding_paywall_benefit_no_ads = /** @type {(inputs: Onboarding_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無廣告，體驗更順暢`)
};

/**
* | output |
* | --- |
* | "Enjoy a smoother, ad-free experience" |
*
* @param {Onboarding_Paywall_Benefit_No_AdsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_no_ads = /** @type {((inputs?: Onboarding_Paywall_Benefit_No_AdsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_No_AdsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_no_ads(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_no_ads(inputs)
	return zh_tw_onboarding_paywall_benefit_no_ads(inputs)
});